import api from '../api'

const state = {
  currentPoiList: [],
  currentPoi: undefined,
  currentTour: {
    type: undefined,
    tour: undefined
  },
  currentPoiListRoute: {
    name: undefined,
    params: undefined
  },
  unfinishedTour: {
    type: undefined,
    tour: undefined,
    poiList: undefined,
    lastVisitedPoi: undefined
  },
  lastVisitedPoi: undefined
}

const getters = {
  getSiblingsPois: (state) => (id) => {
    for (let i = 0; i < state.currentPoiList.length; i++) {
      if (state.currentPoiList[i].id === id) {
        return {
          next: state.currentPoiList[i + 1],
          prev: state.currentPoiList[i - 1]
        }
      }
    }
    return {
      next: undefined,
      prev: undefined
    }
  }
}

const mutations = {
  setCurrentPoiList (state, poiList) {
    state.currentPoiList = poiList
    sessionStorage.currentPoiList = JSON.stringify(poiList)
  },
  setCurrentPoiListRoute (state, route) {
    state.currentPoiListRoute = route
    sessionStorage.currentPoiListRoute = JSON.stringify(route)
  },
  setCurrentPOI (state, poi) {
    state.currentPoi = poi
  },
  setCurrentTour (state, payload) {
    state.currentTour = {
      type: payload.type,
      tour: payload.tour
    }
  },
  clearCurrentTour (state) {
    state.currentTour = {
      type: undefined,
      tour: undefined
    }
  },
  setUnfinishedTour (state, payload) {
    state.unfinishedTour = {
      type: payload.type,
      tour: payload.tour,
      poiList: payload.poiList,
      lastVisitedPoi: payload.lastVisitedPoi
    }
    localStorage.unfinishedTour = JSON.stringify(payload)
  },
  clearUnfinishedTour (state) {
    state.unfinishedTour = {
      type: undefined,
      tour: undefined,
      poiList: undefined,
      lastVisitedPoi: undefined
    }
    localStorage.removeItem('unfinishedTour')
  }
}

const actions = {
  getPOIById ({ commit }, id) {
    api.getPOIById(id).then((response) => {
      commit('setCurrentPOI', response.data)
    })
  },
  trackPoiUnfinishedTour ({ commit, state }, id) {
    if (state.unfinishedTour && state.currentTour.type) {
      let poiIndex = state.unfinishedTour.poiList.findIndex(poi => poi.id === id)
      commit('setUnfinishedTour', {
        type: state.unfinishedTour.type,
        tour: state.unfinishedTour.tour,
        poiList: state.unfinishedTour.poiList,
        lastVisitedPoi: state.unfinishedTour.poiList[poiIndex]
      })
    }
  },
  loadSavedPoiList ({ commit }) {
    if (sessionStorage.currentPoiList && sessionStorage.currentPoiList.length) {
      commit('setCurrentPoiList', JSON.parse(sessionStorage.currentPoiList))
    }
  },
  loadSavedPoiListRoute ({ commit }) {
    if (sessionStorage.currentPoiListRoute) {
      commit('setCurrentPoiListRoute', JSON.parse(sessionStorage.currentPoiListRoute))
    }
  },
  loadUnfinishedTour ({ commit }) {
    if (localStorage.unfinishedTour) {
      commit('setUnfinishedTour', JSON.parse(localStorage.unfinishedTour))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
